// JUSTIFICATIVA

export const formatterJustificativaNull = dadosMinimizados => {
  return {
    justificativa: dadosMinimizados?.justificativa || '',
  };
};

export const formatterJustificativaFrontToBack = (
  justificativa,
  formularioId,
  atendenteId,
  isAtendente,
  statusId,
  setorId
) => {
  return {
    justificativa: justificativa,
    formularioId: formularioId,
    atendenteId: atendenteId,
    isAtendente: isAtendente,
    statusId: statusId,
    setorId: setorId,
  };
};

// JUSTIFICATIVA ENCAMINHAR
export const formatterJustificativaEncaminharNull = (dadosMinimizados, justificativaDefault = '') => {
  return {
    justificativa: dadosMinimizados?.justificativa || justificativaDefault,
    setorEncaminharId: dadosMinimizados?.setorEncaminharId || '',
    setorId: dadosMinimizados?.setorId || '',
    atendenteId: dadosMinimizados?.atendenteId || null,
    formularioId: dadosMinimizados?.formularioId || '',
    statusId: dadosMinimizados?.statusId || '',
    atendenteEncaminharId: dadosMinimizados?.atendenteEncaminharId || '',
  };
};

export const formatterJustificativaEncaminhar = (setorId, atendenteId, formularioId, statusId, justificativa) => {
  return {
    setorId: setorId || null,
    atendenteId: atendenteId || null,
    formularioId: formularioId || null,
    statusId: statusId || null,
    justificativa: justificativa || null,
  };
};
